import React from "react";
import { Button } from "antd";

const ThankYouScreen = ({ onContinue }) => (
  <div style={{ textAlign: "center", padding: "50px" }}>
    <h1 style={{ color: "#165874", marginBottom: "20px" }}>
      Great news! Your business has been matched with the following media and
      marketing agencies.
    </h1>

    <p style={{ fontSize: "18px", maxWidth: "650px", margin: "0 auto" }}>
      Someone from this organization(s) will be in touch soon to talk about how
      they can help you promote your products or services.
    </p>

    <p style={{ fontSize: "16px", marginTop: "20px" }}>
      Have questions? Reach us anytime at{" "}
      <a href="/app/Contact">contact@mediapiq.com</a>.
    </p>
    <br />
    <Button
      type="primary"
      style={{ marginTop: 20, borderRadius: 20 }}
      onClick={onContinue}
    >
      View Matched Companies
    </Button>
  </div>
);

export default ThankYouScreen;
